import React from 'react';
import styles from './ChangePlanGrid.module.scss';
import PageLink from 'components/PageLink/PageLink';
interface Props {
  PageData?: any;
  Model?: any;
}

const ChangePlanGrid = ({ PageData, Model }: Props) => {
  const disabledUpdateAmountButton =
    Model.HasChangePaymentAmountPermission == false ? 'is-disabled' : '';
  const disabledUpdateDateButton =
    Model.HasChangePaymentDatePermission == false ? 'is-disabled' : '';
  const disabledUpdatePaymentMethodButton =
    Model.HasChangePaymentTypePermission == false ? 'is-disabled' : '';

  return (
    <>
      <div className="Changepaymentplan-grid u-marginB">
        {Model.ShowUpdatePaymentPlanAmount && (
          <>
            <div className="Changepaymentplan-grid__Content">
              <div className="Changepaymentplan-headingWrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icons/calculator.svg`}
                />
                <h3
                  className={
                    'Hedaing Changepaymentplan-heading  ' +
                    disabledUpdateAmountButton +
                    ' ' +
                    styles.changeplanheading
                  }
                >
                  {PageData?.ChangeAmounts}
                  {!Model.HasChangePaymentAmountPermission && (
                    <p className="Changepaymentplan-finePrint">
                      {PageData?.ChangePaymentAmountUnavailableMessage}
                    </p>
                  )}
                </h3>
              </div>
            </div>
            <div className="Changepaymentplan-grid__CTAs">
              <PageLink
                className={'Button ' + disabledUpdateAmountButton}
                text={PageData?.ChangePaymentAmountBtnLabel}
                url={Model?.ChangePaymentAmountUrl}
              />
              {!Model.HasChangePaymentAmountPermission && (
                <p className="Changepaymentplan-finePrint u-lg-hidden">
                  {PageData?.ChangePaymentAmountUnavailableMessage}
                </p>
              )}
            </div>
          </>
        )}
        {Model.ShowUpdatePaymentPlanDate && (
          <>
            <div className="Changepaymentplan-grid__Content">
              <div className="Changepaymentplan-headingWrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icons/date-color.svg`}
                />
                <h3
                  className={
                    'Hedaing Changepaymentplan-heading ' +
                    disabledUpdateDateButton +
                    ' ' +
                    styles.changeplanheading
                  }
                >
                  {PageData?.ChangeDate}
                  {!Model.HasChangePaymentDatePermission && (
                    <p className="Changepaymentplan-finePrint">
                      {PageData.ChangePaymentDateUnavailableMessage}
                    </p>
                  )}
                </h3>
              </div>
            </div>
            <div className="Changepaymentplan-grid__CTAs">
              <PageLink
                className={'Button ' + disabledUpdateDateButton}
                text={PageData?.ChangePaymentDateBtnLabel}
                url={Model.ChangePaymentDateUrl}
              />

              {!Model.HasChangePaymentDatePermission && (
                <p className="Changepaymentplan-finePrint u-lg-hidden">
                  {PageData.ChangePaymentDateUnavailableMessage}
                </p>
              )}
            </div>
          </>
        )}
        {Model.ShowUpdatePaymentPlanMethod && (
          <>
            <div className="Changepaymentplan-grid__Content">
              <div className="Changepaymentplan-headingWrapper">
                <img src={`${process.env.PUBLIC_URL}/images/icons/card.png`} />
                <h3
                  className={
                    'Hedaing Changepaymentplan-heading ' +
                    disabledUpdatePaymentMethodButton +
                    ' ' +
                    styles.changeplanheading
                  }
                >
                  {PageData?.ChangePaymentType}
                  {!Model.HasChangePaymentTypePermission && (
                    <p className="Changepaymentplan-finePrint">
                      {PageData?.ChangePaymentMethodUnavailableMessage}
                    </p>
                  )}
                </h3>
              </div>
            </div>
            <div className="Changepaymentplan-grid__CTAs">
              <PageLink
                className={'Button ' + disabledUpdatePaymentMethodButton}
                text={PageData?.ChangePaymentTypeBtnLabel}
                url={Model?.ChangePaymentTypeUrl}
              />
              {!Model.HasChangePaymentTypePermission && (
                <p className="Changepaymentplan-finePrint u-lg-hidden">
                  {PageData?.ChangePaymentMethodUnavailableMessage}
                </p>
              )}
            </div>
          </>
        )}
      </div>
      <div className="u-textCenter w-100 ">
        <PageLink
          className="Changepaymentplan-cancelBtn Button Button--gray Button--wide Button--mobFull"
          url={Model.CancelBtnLinkUrl}
          text={PageData?.CancelBtnLabel}
        />
      </div>
    </>
  );
};
export default ChangePlanGrid;
